<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/rb")
            i.fas.fa-running
            span.ml-1 {{ $t("ui.running_ball") }}
        b-breadcrumb-item
          router-link(to="/rb/dangerzonecorner")
            i.fas.fa-exclamation-triangle
            span.ml-1 {{ $t("ui.danger_zone_corner") }}
    div.row.mb-5
      div.col-md-12
        div.card-group
          div.card
            div.card-header
              div.row
                div.col-md-12.mb-1
                  span.font-weight-bolder {{ $t('ui.rtf') }}
              div.row
                div.col-md-12
                  div.form-row
                    div.col-md-9.mb-1
                      b-input-group(size="sm")
                        b-input-group-text(slot="prepend")
                          i.icon-magnifier
                        DebounceInput(required autofocus type="text" v-model="rtfSearch" :placeholder="$t('message.search_by_id_name_desc')")
                    div.col-md-3.mb-1
                      b-form-radio-group(
                        buttons
                        v-model="rtffilterBy"
                        size="sm"
                        button-variant="outline-info"
                      )
                        b-form-radio(value="id") {{ $t("ui.id") }}
                        b-form-radio(value="name") {{ $t("ui.name") }}
                        b-form-radio(value="desc") {{ $t("ui.description") }}
            div.card-body.p-1.clusterize
              div.clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.text-center.sticky-position(width=60)
                        span {{ $t('ui.action') }}
                      th.text-center.sticky-position(width=60)
                        span {{ $t("ui.id") }}
                      th.sticky-position(width=200)
                        span {{ $t("ui.rtf_name") }}
                      th.sticky-position
                        span {{ $t("ui.description") }}
                  tbody.clusterize-content
                    tr(v-for="(item, index) in filteredRTFList")
                      td.actions.text-center
                        span
                          a.fa.fa-plus.text-primary(href="#" @click="onAdd(item)" :ttile="$t('ui.add')")
                      td.text-center
                        span {{ item.RTFCommentaryID }}
                      td
                        span(:title="item.RTFCommentaryName") {{ item.RTFCommentaryName }}
                      td
                        span(:title="item.RTFCommentaryDescription") {{ item.RTFCommentaryDescription }}
          div.card
            div.card-header
              div.row
                div.col-md-12.mb-1
                  span.font-weight-bold {{ $t('ui.danger_zone_corner') }}
              div.row
                div.col-md-12
                  div.form-row
                    div.col-md-9.mb-1
                      b-input-group(size="sm")
                        b-input-group-text(slot="prepend")
                          i.icon-magnifier
                        DebounceInput(required autofocus type="text" v-model="dzSearch" :placeholder="$t('message.search_by_id_name_desc')")
                    div.col-md-3.mb-1
                      b-form-radio-group(
                        buttons
                        v-model="dzfilterBy"
                        size="sm"
                        button-variant="outline-info"
                      )
                        b-form-radio(value="id") {{ $t("ui.id") }}
                        b-form-radio(value="name") {{ $t("ui.name") }}
                        b-form-radio(value="desc") {{ $t("ui.description") }}
            div.card-body.p-1.clusterize
              div.clusterize-scroll
                table.tablex(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.text-center.sticky-position(width=60)
                        span {{ $t('ui.action') }}
                      th.text-center.sticky-position(width=60)
                        span {{ $t("ui.id") }}
                      th.sticky-position(width=200)
                        span {{ $t("ui.rtf_name") }}
                      th.sticky-position
                        span {{ $t("ui.description") }}
                  tbody
                    tr(v-for="(item, index) in filteredDZList")
                      td.actions.text-center
                        span
                          a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :ttile="$t('ui.delete')")
                      td.text-center
                        span {{ item.RTFCommentaryID }}
                      td
                        span(:title="item.RTFCommentaryName") {{ item.RTFCommentaryName }}
                      td
                        span(:title="item.RTFCommentaryDescription") {{ item.RTFCommentaryDescription }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    DebounceInput
  },
  data() {
    return {
      dzfilterBy: "id",
      rtffilterBy: "id",
      dzList: [],
      rtfList: [],
      rtfSearch: "",
      dzSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      deleteSelectedId: "",
      deleteSelectedName: ""
    };
  },
  computed: {
    filteredDZList() {
      return this.dzList.filter(dz => {
        if (this.dzfilterBy === "name") {
          return dz.RTFCommentaryName.toLowerCase().indexOf(this.dzSearch.toLowerCase()) > -1;
        } else if (this.dzfilterBy === "id") {
          return dz.RTFCommentaryID.toString().indexOf(this.dzSearch) > -1;
        } else if (this.dzfilterBy === "desc" && dz.RTFCommentaryDescription) return dz.RTFCommentaryDescription.toLowerCase().search(this.dzSearch) > -1;
      })
      .sort((a, b) => {
        return a.RTFCommentaryID > b.RTFCommentaryID ? 1 : -1;
      });
    },
    filteredRTFList() {
      return this.rtfList.filter(rtf => {
        if (this.rtffilterBy === "name") {
          return rtf.RTFCommentaryName.toLowerCase().indexOf(this.rtfSearch.toLowerCase()) > -1;
        } else if (this.rtffilterBy === "id") {
          return rtf.RTFCommentaryID.toString().indexOf(this.rtfSearch) > -1;
        } else if (this.rtffilterBy === "desc" && rtf.RTFCommentaryDescription) return rtf.RTFCommentaryDescription.toLowerCase().search(this.rtfSearch) > -1;
      })
      .sort((a, b) => {
        return a.RTFCommentaryID > b.RTFCommentaryID ? 1 : -1;
      });;
    }
  },
  mounted: function() {
    this.getDZList();
    this.getRTFLookupList();
  },
  methods: {
    getDZList() {
      let url = config.getDangerZoneCornerUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.dangerzone
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.dzList = response.data.tbl_dangerzone;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRTFLookupList() {
      let url = config.lookupRtfCommCornerUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.dangerzone
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rtfList = response.data.tbl_lookup_rtfcommentary;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD, HH:mm:ss A");
      return convertDateFormat;
    },
    onAdd(e) {
      let url = config.addDangerZoneCornerUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.dangerzone,
        RTFCommentaryID: e.RTFCommentaryID
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(function(response) {
        this.loading = false;
        // Success
        try {
          if (response) {
            if (typeof response.data.status == "string") {
              this.feedback.success = response.data.status == "1";
            } else {
              this.feedback.success = response.data.status == 1;
            }
            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.addDZ(e.RTFCommentaryID, e.RTFCommentaryName, e.RTFCommentaryDescription);
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      });
    },
    onDelete(e) {
      let url = config.deleteDangerZoneCornerUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.dangerzone,
        RTFCommentaryID: e.RTFCommentaryID
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(function(response) {
        this.loading = false;
        // Success
        try {
          if (response) {
            if (typeof response.data.status == "string") {
              this.feedback.success = response.data.status == "1";
            } else {
              this.feedback.success = response.data.status == 1;
            }
            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.deleteDZ(e.RTFCommentaryID, e.RTFCommentaryName, e.RTFCommentaryDescription);
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      });
    },
    addDZ: function(dzId, dzName, dzDesc) {
      let i = this.rtfList
        .map(rtf => {
          return rtf.RTFCommentaryID;
        })
        .indexOf(dzId);
      this.rtfList.splice(i, 1);

      let newdz = {
        RTFCommentaryID: dzId,
        RTFCommentaryName: dzName,
        RTFCommentaryDescription: dzDesc
      };

      this.dzSearch = "";
      this.dzList.unshift(newdz);
    },
    deleteDZ: function(dzId, dzName, dzDesc) {
      let i = this.dzList
        .map(dz => {
          return dz.RTFCommentaryID;
        })
        .indexOf(dzId);
      this.dzList.splice(i, 1);

      let newrtf = {
        RTFCommentaryID: dzId,
        RTFCommentaryName: dzName,
        RTFCommentaryDescription: dzDesc
      };

      this.rtfSearch = "";
      this.rtfList.unshift(newrtf);
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
